import * as DomTypeUtils from '@packages/systems/core/utils/DomTypeUtils';
import type {Context} from '../types';

// Strip out static innerHTML for dynamic embed nodes which contain data.embed.meta.html content
export default (context: Context) => {
  const {
    node: {jsonNode},
  } = context;
  const {data = {}} = jsonNode;
  const isCompilableHtmlEmbed = DomTypeUtils.isCompilableHtmlEmbed(data);
  const metaHtml = data.embed && data.embed.meta && data.embed.meta.html;

  return {
    needed: isCompilableHtmlEmbed && jsonNode.v && metaHtml,
    logData: {
      msg: 'CompilableHtmlEmbed with static v',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      // eslint-disable-next-line webflow/no-delete
      delete jsonNode.v;
    },
  };
};
